import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a14f385"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Get started with Beamian"),
  /*#__PURE__*/_createElementVNode("p", null, "Create an account and you’re good to go!")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beamian.com/legal-policies/",
    target: "_blank"
  }, "beamian terms and conditions")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "colored-bg full-height"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Get started with Beamian"),
  /*#__PURE__*/_createElementVNode("p", null, "Create an account and you’re good to go!")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://beamian.com/legal-policies/",
    target: "_blank"
  }, "beamian terms and conditions")
], -1))
const _hoisted_7 = { style: {"width":"300px","margin":"50px auto 30px auto"} }
const _hoisted_8 = { class: "container" }

import { personAdd } from "ionicons/icons";

import {
  IonPage,
  IonLabel,
  IonItem,
  IonNote,
  IonFooter,
  IonList,
  IonContent,
  IonInput,
  IonCheckbox,
  IonButton,
  IonLoading,
  IonIcon,
  IonTitle,
  IonButtons,
  IonHeader,
  IonToolbar,
  IonBackButton,
  useIonRouter,
} from "@ionic/vue";
import { useForm } from "../..";
import { addUser } from "@/api/users";
import { computed, reactive } from "vue";
import { useToasters } from "@/composition/toasters";
import { useWindowWidth } from "@/composition/window";
import { event as gtag_event } from "vue-gtag";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAccount',
  setup(__props) {

const { isMobile } = useWindowWidth();
const router = useIonRouter();
const form = useForm();

const state = reactive({
  loading: false,
  acceptedTerms: false,
  errors: {
    email: [],
    name: [],
    password: [],
  },
});

const toasters = useToasters();

const emptyFieldsPresent = computed(
  () =>
    form.user.name === "" ||
    form.user.email === "" ||
    form.user.password === "" ||
    form.user.confirm_password === "" ||
    !state.acceptedTerms
);

const createUser = () => {
  state.loading = true;
  state.errors = {
    email: [],
    name: [],
    password: [],
  };
  addUser(form.user)
    .then((response) => {
      state.loading = false;

      if (response.status === 201) {
        gtag_event("sign_up", {
          category: "check-in app",
          label: "New registration",
        });

        router.push("/onboarding/verify-email");
      }
    })
    .catch((err) => {
      if (Array.isArray(err.response.data)) {
        toasters.addError(err.response.data[0]);
      } else {
        state.errors = { ...state.errors, ...err.response.data };
      }

      state.loading = false;
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    color: "white",
                    "default-href": "/onboarding/introduction"
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("New account")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonContent), { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.name.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Name")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        modelValue: _unref(form).user.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).user.name) = $event)),
                        placeholder: "John Doe",
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.name, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `name-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.email.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Email")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "email",
                        modelValue: _unref(form).user.email,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).user.email) = $event)),
                        placeholder: "john.doe@gmail.com"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.email, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `email-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.password.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Password")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "password",
                        modelValue: _unref(form).user.password,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).user.password) = $event)),
                        placeholder: "********"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.password, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `password-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({
            'ion-invalid':
              _unref(form).user.password !== '' &&
              _unref(form).user.password !== _unref(form).user.confirm_password,
          })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Confirm password")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "password",
                        modelValue: _unref(form).user.confirm_password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).user.confirm_password) = $event)),
                        placeholder: "********"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(IonNote), { slot: "error" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Passwords do not match ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), { style: {"padding":"1.5rem 0","--border-color":"#fff"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCheckbox), {
                        modelValue: state.acceptedTerms,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.acceptedTerms) = $event)),
                        style: {"margin-right":"5px"}
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(IonNote), {
                        class: "terms",
                        color: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" I confirm that I have read and agree to "),
                          _hoisted_2,
                          _createTextVNode(". ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), { style: {"--border-color":"#fff"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCheckbox), {
                        modelValue: _unref(form).user.emails_opt_in,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).user.emails_opt_in) = $event)),
                        style: {"margin-right":"5px"}
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(IonNote), {
                        class: "terms",
                        color: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" I want to receive emails about new features and updated app versions. ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.name.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Name")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        modelValue: _unref(form).user.name,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).user.name) = $event)),
                        placeholder: "John Doe",
                        type: "text"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.name, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `name-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.email.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Email")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "email",
                        modelValue: _unref(form).user.email,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).user.email) = $event)),
                        placeholder: "john.doe@gmail.com"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.email, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `email-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({ 'ion-invalid': state.errors.password.length > 0 })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Password")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "password",
                        modelValue: _unref(form).user.password,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).user.password) = $event)),
                        placeholder: "********"
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.errors.password, (message, i) => {
                        return (_openBlock(), _createBlock(_unref(IonNote), {
                          slot: "error",
                          key: `password-error-${i}`
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), {
                    class: _normalizeClass({
              'ion-invalid':
                _unref(form).user.password !== '' &&
                _unref(form).user.password !== _unref(form).user.confirm_password,
            })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { position: "stacked" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Confirm password")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonInput), {
                        type: "password",
                        modelValue: _unref(form).user.confirm_password,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).user.confirm_password) = $event)),
                        placeholder: "********"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(IonNote), { slot: "error" }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Passwords do not match ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_unref(IonItem), { style: {"padding-top":"1rem","--border-color":"#fff"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCheckbox), {
                        modelValue: state.acceptedTerms,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((state.acceptedTerms) = $event)),
                        style: {"margin-right":"5px"}
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(IonNote), {
                        class: "terms",
                        color: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" I confirm that I have read and agree to "),
                          _hoisted_6,
                          _createTextVNode(". ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonItem), { style: {"--border-color":"#fff"} }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCheckbox), {
                        modelValue: _unref(form).user.emails_opt_in,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).user.emails_opt_in) = $event)),
                        style: {"margin-right":"5px"}
                      }, null, 8, ["modelValue"]),
                      _createVNode(_unref(IonNote), {
                        class: "terms",
                        color: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" I want to receive emails about new features and updated app versions. ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(IonButton), {
                  expand: "block",
                  color: "success",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (createUser())),
                  disabled: emptyFieldsPresent.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(personAdd)
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Continue ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ])),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("section", null, [
                  _createVNode(_unref(IonButton), {
                    expand: "block",
                    color: "success",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (createUser())),
                    disabled: emptyFieldsPresent.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "start",
                        icon: _unref(personAdd)
                      }, null, 8, ["icon"]),
                      _createTextVNode(" Continue ")
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})